export default __webpack_public_path__ + "static/media/figma.fcda3297.png";